import { ToggleButtonGroup, styled } from "@mui/material";
import { background, text } from "@/theme/colors";

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  backgroundColor: background.disable,
  borderRadius: "999px",
  padding: "4px",
  "& .MuiToggleButtonGroup-grouped": {
    height: "37px",
    border: "none",
    borderRadius: "999px",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "lowercase",
    minWidth: "120px",
    textAlign: "center",
    transition: "all 0.2s ease-in-out",
    letterSpacing: 0,
    "&.Mui-selected": {
      backgroundColor: background.primary,
      color: text.primary,
      fontWeight: 500,
      "&:hover": {
        backgroundColor: background.primary,
      },
      "&:active": {
        transform: "scale(0.96)",
        transition: "transform 0.1s ease-in-out",
      },
    },
    "&:not(.Mui-selected)": {
      color: text.secondary,
      backgroundColor: "transparent",
      "&:active": {
        transform: "scale(0.96)",
        transition: "transform 0.1s ease-in-out",
      },
    },
  },
}));
